import { render, staticRenderFns } from "./ImportBrandJoinRecord.vue?vue&type=template&id=779904ba"
import script from "./ImportBrandJoinRecord.vue?vue&type=script&lang=js"
export * from "./ImportBrandJoinRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports